import { Sun, Moon, Monitor } from "lucide-react";
import { useThemeStore } from "@/lib/theme/theme-store";
import { Button } from "@/components/ui/button";

/**
 * Cycles through light → dark → system on each click.
 * Place in the app-shell topbar.
 */
export function ThemeToggle() {
  const { theme, set } = useThemeStore();

  const cycle = () => {
    const next = theme === "light" ? "dark" : theme === "dark" ? "system" : "light";
    set(next);
  };

  const icon =
    theme === "light" ? <Sun size={16} /> :
    theme === "dark" ? <Moon size={16} /> :
    <Monitor size={16} />;

  const label =
    theme === "light" ? "Sáng" :
    theme === "dark" ? "Tối" :
    "Hệ thống";

  return (
    <Button
      variant="ghost"
      size="sm"
      onClick={cycle}
      className="gap-1.5 text-muted-foreground"
      title={`Giao diện: ${label}`}
    >
      {icon}
      <span className="hidden sm:inline text-xs">{label}</span>
    </Button>
  );
}
